// extracted by mini-css-extract-plugin
export default {"text":"AppDetails_text__iQ-6o","separator":"AppDetails_separator__RwaNL"};